import { useAuthentication, useTranslation } from '@topcon/topcon-utils';
import { TeButton, TeContainerSlim, TeText } from '@topcon/tuicl-react';
import styled from 'styled-components';

const ContinueButton = styled(TeButton)`
  width: 128px;
`;

function ContinueCard({
  title,
  description,
  buttonLabel,
  onContinue,
}: {
  title?: string;
  description?: string;
  buttonLabel?: string;
  onContinue?: () => void | Promise<void>;
}) {
  const { t } = useTranslation('common');
  const authService = useAuthentication();

  const handleContinue = async () => {
    if (onContinue) {
      await onContinue();
    } else {
      authService.login();
    }
  };

  return (
    <TeContainerSlim
      fill
      grow
      column
      gap="s"
      padding="s"
      justifyContent="center"
      alignItems="center"
      backgroundColor="background.secondary"
      borderColor="border.secondary"
      borderRadius="l"
    >
      <TeContainerSlim
        fill
        grow
        column
        justifyContent="center"
        alignItems="center"
        gap={4}
        padding={0}
      >
        <TeText weight={700} size={12} alignment="center">
          {title ?? t('topconContinueCardTitle')}
        </TeText>
        <TeText weight={400} size={12} alignment="center" color="text.secondary">
          {description ?? t('topconContinueCardDescription')}
        </TeText>
      </TeContainerSlim>
      <ContinueButton
        grow
        text={buttonLabel ?? t('topconContinueCardButtonLabel')}
        size="s"
        teclick={handleContinue}
      />
    </TeContainerSlim>
  );
}

export default ContinueCard;
